import { PoolCarousel } from '@synergy/components-next';
import { ReactElement } from 'react';

import { ArticlePlaceholderImage } from '../../../components/article-placeholder-image/article-placeholder-image';
import { SquareBox } from '../../../components/square-box/square-box';
import { useArticleDetailContext } from '../article-detail';

export const ArticleDetailPreviewImageMobile = (): ReactElement | null => {
    const { images, supplier } = useArticleDetailContext().article;

    if (images.length === 0) {
        return <ArticlePlaceholderImage supplier={supplier} imageCachePath="375x375" />;
    }

    return (
        <PoolCarousel alignIndicatorButton="bottom" autoPlay={false}>
            {images.map(image => (
                <SquareBox key={image}>
                    <img
                        src={image}
                        alt={image}
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                </SquareBox>
            ))}
        </PoolCarousel>
    );
};
